<template>
  <div>
    <DnStepper  
      v-show="this.$parent.claimDto.ClaimType === 'PartsIssue'"
      ref="partsIssueStepper"
      stepper-id="partsIssueStepper"
      :tabs="partsIssueTabs"
      :initial-active-tab-id="initialActiveTabId"
      @clickedNextOrSubmitButton="TryNextOrSubmit"
      @clickedBackButton="ResetClaimSubmissionStatus"
    >
      <template #content-for-tab-1>
        <CreateClaimOrderLookup 
          :claim-dto="claimDto"
          :validation-state="claimStepsValidState"
          @selectedInvoice="SetInvoiceData"
          @selectedClaimType="SetClaimType"
        />
      </template>
      <template #content-for-tab-2>
        <CreateClaimSelectParts
          ref="selectParts"
          :invoice-data="invoiceData"
          :invoice-state="savedInvoiceState"
          :validation-state="claimStepsValidState"
          :claim-dto="claimDto"
          @error="SetErrorMessage"
        />
      </template>
      <template #content-for-tab-3>
        <CreateClaimClaimInfo
          ref="claimInfoParts"
          :claim-dto="claimDto"
          :validation-state="claimStepsValidState"
          images-upload-modal-id="imagesUploadModalForPartsIssues"
        />
      </template>
      <template #content-for-tab-4>
        <CreateClaimContactInfo
          :contact-info="claimDto"
          :validation-state="claimStepsValidState"
        />
      </template>
      <template #content-for-tab-5>
        <CreateClaimReviewAndSubmit
          :claim-dto="claimDto"
        />
      </template>
    </DnStepper>
    <!-- Stepper for Extra Parts Claim Type -->
    <DnStepper
      v-show="this.$parent.claimDto.ClaimType === 'ExtraParts'"
      ref="extraPartsStepper"
      stepper-id="extraPartsStepper"
      :tabs="extraPartsTabs"
      :initial-active-tab-id="initialActiveTabId"
      @clickedNextOrSubmitButton="TryNextOrSubmit"
      @clickedBackButton="ResetClaimSubmissionStatus"
    >
      <template #content-for-tab-1>
        <CreateClaimOrderLookup 
          :claim-dto="claimDto"
          :validation-state="claimStepsValidState"
          @selectedInvoice="SetInvoiceData"
          @selectedClaimType="SetClaimType"
        />
      </template>
      <template #content-for-tab-2>
        <CreateClaimAddParts
          ref="addParts"
          :invoice-data="invoiceData"
          :invoice-state="savedInvoiceState"
          :validation-state="claimStepsValidState"
          :claim-dto="claimDto"
          @error="SetErrorMessage"
        />
      </template>
      <template #content-for-tab-3>
        <CreateClaimClaimInfo
          ref="claimInfoExtra"
          :claim-dto="claimDto"
          :validation-state="claimStepsValidState"
          images-upload-modal-id="imagesUploadModalForExtraParts"
        />
      </template>
      <template #content-for-tab-4>
        <CreateClaimContactInfo
          :contact-info="claimDto"
          :validation-state="claimStepsValidState"
        />
      </template>
  
      <template #content-for-tab-5>
        <CreateClaimReviewAndSubmit
          :claim-dto="claimDto"
        />
      </template>
    </DnStepper>
    <!-- Stepper for Frieght Only Claim Type -->
    <DnStepper
      v-show="this.$parent.claimDto.ClaimType === 'FreightOnly'"
      ref="freightOnlyStepper"
      stepper-id="freightOnlyStepper"
      :tabs="freightOnlyTabs"
      :initial-active-tab-id="initialActiveTabId"
      @clickedNextOrSubmitButton="TryNextOrSubmit"
      @clickedBackButton="ResetClaimSubmissionStatus"
    >
      <template #content-for-tab-1>
        <CreateClaimOrderLookup 
          :claim-dto="claimDto"
          :validation-state="claimStepsValidState"
          @selectedInvoice="SetInvoiceData"
          @selectedClaimType="SetClaimType"
        />
      </template>
      <template #content-for-tab-2>
        <CreateClaimFreightClaimInfo
          ref="freightClaimInfo"
          :claim-dto="claimDto"
          :validation-state="claimStepsValidState"
        />
      </template>
      <template #content-for-tab-3>
        <CreateClaimContactInfo
          :contact-info="claimDto"
          :validation-state="claimStepsValidState"
        />
      </template>
      <template #content-for-tab-4>
        <CreateClaimReviewAndSubmit
          :claim-dto="claimDto"
        />
      </template>
    </DnStepper>
  </div>
</template>

<script>
  import $                           from "jquery"
  import DnStepper                   from "@/components/Elements/DnStepper"
  import CreateClaimOrderLookup      from "./CreateClaimOrderLookup"
  import CreateClaimSelectParts      from "./CreateClaimSelectParts"
  import CreateClaimAddParts         from "./CreateClaimAddParts"
  import CreateClaimClaimInfo        from "./CreateClaimClaimInfo"
  import CreateClaimFreightClaimInfo from "./CreateClaimFreightClaimInfo"
  import CreateClaimContactInfo      from "./CreateClaimContactInfo"
  import CreateClaimReviewAndSubmit  from "./CreateClaimReviewAndSubmit"
  import ClaimSubmission             from "./ClaimSubmission"

  // mixins
  import { stringHelper }            from "@/components/mixins/stringHelper"
  import { sizeHelper }              from "@/components/mixins/sizeHelper"
  import { siteSectionsHelper }      from "@/components/mixins/siteSectionsHelper"

  export default {
    components: {
      DnStepper,
      CreateClaimOrderLookup,
      CreateClaimSelectParts,
      CreateClaimAddParts,
      CreateClaimClaimInfo,
      CreateClaimFreightClaimInfo,
      CreateClaimContactInfo,
      CreateClaimReviewAndSubmit,
    },

    mixins: [stringHelper, sizeHelper, siteSectionsHelper],

    props: {
      initialActiveTabId: {
        type: String,
        default: "orderLookupTab"
      },
    },

    data: () => ({ 
      currentTabId: "orderLookupTab",
      tabs: [
        {tabId: "orderLookupTab", stepNumber: 1, tabName: "Order Lookup"}
      ],
      extraPartsTabs: [
        {tabId: "orderLookupTab",     stepNumber: 1, tabName: "Start"},
        {tabId: "addPartsTab",        stepNumber: 2, tabName: "Add Parts"},
        {tabId: "claimInfoTab",       stepNumber: 3, tabName: "Claim Info"},
        {tabId: "contactInfoTab",     stepNumber: 4, tabName: "Contact Info"},
        {tabId: "reviewAndSubmitTab", stepNumber: 5, tabName: "Review & Submit"}
      ],
      partsIssueTabs: [
        {tabId: "orderLookupTab",     stepNumber: 1, tabName: "Order Lookup"},
        {tabId: "selectPartsTab",     stepNumber: 2, tabName: "Select Parts"},
        {tabId: "claimInfoTab",       stepNumber: 3, tabName: "Claim Info"},
        {tabId: "contactInfoTab",     stepNumber: 4, tabName: "Contact Info"},
        {tabId: "reviewAndSubmitTab", stepNumber: 5, tabName: "Review & Submit"}
      ],
      freightOnlyTabs: [
        {tabId: "orderLookupTab",      stepNumber: 1, tabName: "Order Lookup"},
        {tabId: "freightClaimInfoTab", stepNumber: 2, tabName: "Claim Info"},
        {tabId: "contactInfoTab",      stepNumber: 3, tabName: "Contact Info"},
        {tabId: "reviewAndSubmitTab",  stepNumber: 4, tabName: "Review & Submit"}
      ],
      claimStepsValidState: {
        orderLookupTab: false,
        addPartsTab: false,
        selectPartsTab: false,
        claimInfoTab: false,
        freightClaimInfoTab: false,
        contactInfoTab: false,
        reviewAndSubmitTab: false,
        addPartsTabCurrentlyValidating: false
      },
      invoiceData: {
        invoiceId: Number,
        invoiceSource: String
      },
      savedInvoiceState: {},
    }),

    computed: {
      claimDto(){
        return this.$parent.claimDto;
      }
    },
    
    methods: {
      ResetClaimSubmissionStatus(){
        this.$emit("ResetClaimStatusEnumeration");
      },
      GetCurrentStepper(){
        switch(this.claimDto.ClaimType){
        case "PartsIssue":
          return this.$refs.partsIssueStepper
          break
        case "FreightOnly":
          return this.$refs.freightOnlyStepper
          break
        case "ExtraParts":
          return this.$refs.extraPartsStepper
          break
        default:
          //error
          break
        }
      },
      TryNextOrSubmit: function () {
        // Show ClaimSubmission component only in the 'Review and Submit' tab
        if(this.GetCurrentStepper().currentTabId === "reviewAndSubmitTab"){
          this.ClaimStatusEnumeration = 1;
        }
        else{
          this.ClaimStatusEnumeration = 0;
        }

        switch (this.GetCurrentStepper().currentTabId) {
        case "orderLookupTab":
          this.ValidateOrderLookupStep()
          break
        case "addPartsTab":
          this.ValidateAddPartsStep()
          break
        case "selectPartsTab":
          this.ValidateSelectPartsStep()
          break
        case "claimInfoTab":
          this.ValidateClaimInfoStep()
          break
        case "uploadImagesTab":
          this.GetCurrentStepper().GoToNextTab();
          break
        case "freightClaimInfoTab":
          this.ValidateFreightClaimInfoTab()
          break
        case "contactInfoTab":
          this.ValidateContactInfoStep()
          break
        case "reviewAndSubmitTab":
          this.$emit("ReviewSubmit");
          break
        default:
          //error
          break
        }
      },
      GetCurrentTabId(){
        return this.currentTabId;
        //this.$emit("GetTab");
      },
      SetInvoiceData (selectedInvoiceData) {
        this.claimDto.Items = [];
        this.invoiceData = {
          invoiceId: selectedInvoiceData.invoiceId,
          invoiceSource: selectedInvoiceData.invoiceSource
        };
        this.claimDto.SalesOrganization   = selectedInvoiceData.salesOrg;
        this.claimDto.OrderNumber         = selectedInvoiceData.orderNumber;
        this.claimDto.InvoiceSource       = selectedInvoiceData.invoiceSource;
        this.claimDto.InvoiceNumber       = selectedInvoiceData.invoiceNumber;
        this.claimDto.InvoiceDate         = selectedInvoiceData.invoiceDate;
        this.claimDto.InvoiceFreight      = selectedInvoiceData.invoiceFreight;
        this.claimDto.SourceInvoiceNumber = selectedInvoiceData.SourceInvoiceNumber;
        this.claimDto.SourceCode          = selectedInvoiceData.SourceCode;
      },
      SetClaimType (claimType) {
        this.claimDto.Items = [];
        this.claimDto.ClaimType = claimType;
      },
      SetErrorMessage: function (message) {
        this.errorMessage = message;
        window.scrollTo(0,0);
      },
      ValidateOrderLookupStep: function () {      
        if (this.isNullOrWhiteSpace(this.claimDto.CustomerReferenceNumber)) {
          this.SetErrorMessage("Please enter a reference number to continue")
          return
        }
        if (this.invoiceData.invoiceId === Number && this.claimDto.ClaimType  !== "ExtraParts") {
          this.SetErrorMessage("Please search for and select an invoice to continue")
          return
        }
        if (this.invoiceData.invoiceId !== Number || this.claimDto.ClaimType  === "ExtraParts" ) {
          // clear error message before getting to next page.
          this.SetErrorMessage("");

          if(this.claimDto.ClaimType === "PartsIssue"){
            this.$refs.selectParts.Setup();
          }

          this.GetCurrentStepper().GoToNextTab();
        }
      },
      ValidateSelectPartsStep: function () {
        if (this.claimStepsValidState.selectPartsTab) {
          this.GetCurrentStepperClaimInfoComponent().Setup();
          this.GetCurrentStepper().GoToNextTab();
        } else {
          this.SetErrorMessage("Please select at least one part to continue")
        }
      },
      ValidateAddPartsStep: function () {
        let self = this;
        this.$refs.addParts.ValidateParts().then(parts => {
          let validPartOemCodes= [];
          let validParts = [];
          if(self.IsNotNullOrUndefined(parts, "data"))
          {
            parts.data.forEach(function(part, index) {
  
              validPartOemCodes.push(part.OemPartCode);
              validParts.push(part);
                  
            });
          }

          let partCodeInputs = $("#claimItemSelection tr #OemPartCode");
          let haveAnInvalidPart = false;

          for(let i = 0; i < partCodeInputs.length; i++){
            var partCodeElement = $(partCodeInputs[i]);
            
            if(!validPartOemCodes.includes(partCodeElement.val()) )
            {
              haveAnInvalidPart= true;
              $(partCodeElement).css("border", "2px solid red");
            }
            else
            {
              $(partCodeElement).css("border", "2px solid green");
            }
          }

          if (!haveAnInvalidPart) {
            this.GetClaimInfoParts(validParts, true);            
          } else {
            self.SetErrorMessage("Part numbers cannot be left blank and must be valid, if the part number is highlighted in red, it is not valid.")
          }
        });
      },
      GetCurrentStepperClaimInfoComponent(){
        switch(this.claimDto.ClaimType){
        case "PartsIssue":
          return this.$refs.claimInfoParts
          break
        case "ExtraParts":
          return this.$refs.claimInfoExtra
          break
        default:
          //error
          break
        }
      },
      GetClaimInfoParts(parts){
        let self = this;
        let tempItems = [];
        // Build an item object for every part
        parts.forEach(function(part, index) {
          // Setup required fields that aren't on the part
          let quantity = 0;
          let orderLineNumber = 0;

          let partCodeInput = $("#claimItemSelection tr #OemPartCode").filter(function( index, partInput ) {
            return $(partInput).val() === part.OemPartCode;
          });
          quantity = partCodeInput.closest("tr").find("#itemQuantity").val();

          if( quantity === 0){
            return;
          }
          
          // create the item
          let item = {
            ClaimReason: "None",
            ExtendedPrice: part.DealerNetPrice * quantity,
            ImageUrl: part.ImageUrl,
            InvoiceNumber: self.claimDto.InvoiceNumber,
            OrderedOemPartCode: part.OemPartCode,
            OrderedPrice: part.DealerNetPrice,
            OrderedQuantity: quantity,
            PartDescription: part.PartDescription,
            PartId: part.Id,
            ReturnOemPartCode: part.OemPartCode,
            ReturnPrice: part.DealerNetPrice,
            ReturnQuantity: quantity,
            selected: true
          }

          if( orderLineNumber !== 0){
            item.OrderLineNumber = orderLineNumber
          }

          tempItems.push(item);
        });

        // save the items and move on
        this.claimDto.Items = tempItems;

        self.GetCurrentStepper().GoToNextTab();
      },
      ValidateClaimInfoStep: function () {
        // if the claim type is extra parts, we don't have to validate the file uploads
        if (this.claimStepsValidState.claimInfoTab && this.claimDto.ClaimType === "ExtraParts") {
          this.GetCurrentStepper().GoToNextTab();
        }

        if (this.claimStepsValidState.claimInfoTab && this.claimDto.ClaimType === "PartsIssue") {
          // once the form inputs are validated, only allow next if the image button was never pushed OR
          //  if it was pushed, that they clicked on the addFilesToRequest button to attach the file to the form
          var filesAdded = document.forms["theForm"].elements["theFiles"].value;

          if ((filesAdded.length > 0 && this.$refs.claimInfoParts.addFilesToRequest) || filesAdded.length === 0) {
            this.GetCurrentStepper().GoToNextTab();
          }
        }
      },
      ValidateFreightClaimInfoTab: function () {
        if (this.claimStepsValidState.freightClaimInfoTab) {
          this.GetCurrentStepper().GoToNextTab();
        }
        else{
          this.$refs.freightClaimInfo.showCommentValidation = true;
          this.$refs.freightClaimInfo.showCreditValidation = true;
        }
      },
      ValidateContactInfoStep: function () {
        if (this.claimStepsValidState.contactInfoTab) {
          this.GetCurrentStepper().GoToNextTab();
        }
      }   
    }
  }
</script>